import LoginView from "../LoginView.vue";
import LoginPage from "../Pages/LoginPage.vue";
import ResetPasswordPage from "../Pages/ResetPasswordPage.vue";

const routes = [
  {
    path: '/login',
    component: LoginView,
    children: [
      {
        path: '',
        name: 'login',
        component: LoginPage,
        meta: {excludeAuth: true}
      }
    ]
  },
  {
    path: '/actualizar-contrasena/:token',
    name: 'actualizar-contrasena',
    component: ResetPasswordPage,
    meta: {excludeAuth: true}
  }
]

export default routes
